export default __webpack_public_path__ + "media/Self-Care.2ff101cb.svg";